module.exports = __webpack_public_path__ + "img/flat-lay-desktop-with-laptop-glasses.5f33fc13.png";